import { CLEAR_ALL_ATTACHMENTS } from "../action.js";

export const clearAllAttachments = (markForDelete = false) => {
  return (dispatch) => {
    dispatch({ type: CLEAR_ALL_ATTACHMENTS, payload: markForDelete });
  };
};
